import React from 'react';
import { CheckIcon, GiftIcon, LockIcon } from 'lucide-react';
import { bonuses, modules, priceToday, totalValue } from '../data/content';
import { CtaButton } from './CtaButton';
export function ValueStack() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="w-full bg-ivory" data-id="element-113" data-mp="1q9ec7jabv42n">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10 lg:py-24" data-id="element-114" data-mp="1u96h9m0iis39">
        <div className="max-w-3xl" data-id="element-115" data-mp="2hzsmz6n1o0a3">
          <p className="font-sans text-xs font-semibold uppercase tracking-[0.2em] text-wine" data-id="element-116" data-mp="2i0kadu6hmrpa">
            Esto es todo lo que recibes hoy
          </p>
          <h2 id="oferta-titulo" className="mt-5 font-display text-3xl font-semibold leading-tight text-ink sm:text-[2.8rem]" data-id="element-117" data-mp="29776xyass7oy">
            Wedding Bliss &amp; Fun System™
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-12 lg:grid-cols-[1.35fr_1fr] lg:gap-16" data-id="element-118" data-mp="30y50f4kznwbh">
          <div data-id="element-119" data-mp="35pd6bqn40zjw">
            <ul className="border-t border-blush" data-id="element-120" data-mp="35pwq7cwbly0k">
              {modules.map(mod => <li key={mod.label} className="grid grid-cols-[auto_1fr] items-start gap-x-4 gap-y-2 border-b border-blush py-6 sm:grid-cols-[auto_1fr_auto] sm:gap-x-6" data-id="element-121" data-mp="1tgel44e6vwvu">
                  <CheckIcon aria-hidden="true" className="mt-1 h-5 w-5 shrink-0 text-olive" data-id="element-122" data-mp="236r5nwm07q1z" />
                  <div data-id="element-123" data-mp="2c5bf075ocndj">
                    <p className="font-sans text-[0.7rem] font-semibold uppercase tracking-[0.16em] text-muted" data-id="element-124" data-mp="2c4t7gedkamqb">
                      {mod.label}
                    </p>
                    <h3 className="mt-1 font-display text-2xl leading-snug text-ink" data-id="element-125" data-mp="2m4k68s95nnw7">
                      {mod.title}
                    </h3>
                    <p className="mt-2 max-w-prose font-sans text-[0.95rem] leading-relaxed text-muted" data-id="element-126" data-mp="2h5gyv15pd5l2">
                      {mod.items}
                    </p>
                  </div>
                  <p className="col-start-2 font-sans text-sm text-muted sm:col-start-3 sm:pt-5 sm:text-right" data-id="element-127" data-mp="ms7xjwnb8qdw">
                    Valor <span className="font-semibold text-ink" data-id="element-128" data-mp="2mv0gibhx46yq">{mod.value}</span>
                  </p>
                </li>)}
            </ul>

            <div className="mt-12 rounded-[1.5rem] bg-cream p-7 sm:p-9" data-id="element-129" data-mp="2vtcfb0sxub29">
              <div className="flex items-center gap-3" data-id="element-130" data-mp="30sxe9b83yjez">
                <GiftIcon aria-hidden="true" className="h-5 w-5 text-wine" data-id="element-131" data-mp="30ui9z465s8ef" />
                <h3 className="font-sans text-xs font-semibold uppercase tracking-[0.2em] text-wine" data-id="element-132" data-mp="35stgp615q2sf">
                  5 bonos exclusivos si compras hoy
                </h3>
              </div>
              <ul className="mt-6 grid grid-cols-1 gap-x-8 gap-y-7 sm:grid-cols-2" data-id="element-133" data-mp="3fhl5j5ax86z4">
                {bonuses.map(bonus => <li key={bonus.label} className="flex h-full flex-col" data-id="element-134" data-mp="3jix07p8njie6">
                    <p className="font-sans text-[0.7rem] font-semibold uppercase tracking-[0.16em] text-muted" data-id="element-135" data-mp="3ojb02k03nm14">
                      {bonus.label}
                    </p>
                    <h4 className="mt-1 font-display text-xl leading-snug text-ink" data-id="element-136" data-mp="7fvnu1lgr1kh">
                      {bonus.title}
                    </h4>
                    <p className="mt-2 font-sans text-[0.95rem] leading-relaxed text-muted" data-id="element-137" data-mp="2fhcoaokfbi8">
                      {bonus.items}
                    </p>
                    <p className="mt-auto pt-4 font-sans text-sm text-muted" data-id="element-138" data-mp="3pm1my341tw51">
                      Valor <span className="font-semibold text-ink" data-id="element-139" data-mp="q6n47n3vbs8d">{bonus.value}</span>
                    </p>
                  </li>)}
              </ul>
            </div>
          </div>

          <aside className="lg:sticky lg:top-10 lg:self-start" data-id="element-140" data-mp="l9wfychwtqbv">
            <div className="overflow-hidden rounded-[1.5rem] border border-blush bg-white" data-id="element-141" data-mp="gfadiytt383x">
              <img src="https://cdn.magicpatterns.com/patterns/generated-images/d58bd55e-ef2d-49d2-9504-8ca472cc54c5.jpg" alt="Un niño colorea un libro de actividades de boda en la mesa" className="aspect-[4/3] w-full object-cover" loading="lazy" data-id="element-142" data-mp="cegkxs5f554p" />
              <div className="p-7 sm:p-8" data-id="element-143" data-mp="oqhfsnx5yxwk">
                <div className="flex items-baseline justify-between" data-id="element-144" data-mp="tnrdequpifvh">
                  <p className="font-sans text-sm text-muted" data-id="element-145" data-mp="fnq18f8zrm0p">Valor total</p>
                  <p className="font-display text-2xl text-muted line-through" data-id="element-146" data-mp="fpt0lpw1ari3">{totalValue}</p>
                </div>
                <div className="mt-4 flex items-baseline justify-between border-t border-blush pt-4" data-id="element-147" data-mp="jr4q7vewrcqa">
                  <p className="font-sans text-sm font-semibold uppercase tracking-[0.16em] text-wine" data-id="element-148" data-mp="1cdzaosbq6c3r">
                    Precio hoy
                  </p>
                  <p className="font-display text-4xl font-semibold leading-none text-ink sm:text-5xl" data-id="element-149" data-mp="ym2mv0h3aod6">
                    {priceToday}
                    <span className="ml-1.5 font-sans text-base font-medium text-muted" data-id="element-150" data-mp="12ltc2zqywwfl">ARS</span>
                  </p>
                </div>

                <CtaButton className="mt-7 w-full" data-id="element-151" data-mp="1v5icwwxxdm4q">
                  Sí, quiero una boda divertida y sin estrés
                </CtaButton>

                <p className="mt-4 text-center font-sans text-sm leading-relaxed text-muted" data-id="element-152" data-mp="3fssu0kq1qfpv">
                  Pago único · Acceso de por vida · Descarga inmediata
                </p>
                <p className="mt-5 flex items-center justify-center gap-2 border-t border-blush pt-5 font-sans text-xs uppercase tracking-[0.14em] text-muted" data-id="element-153" data-mp="3pjxa5nrgk6ma">
                  <LockIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-154" data-mp="2wv86bgz0pn6u" />
                  Garantía de 7 días
                </p>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>;
}